export enum accountStatuses {
  verified = "Verified",
  unverified = "Unverified",
  blocked = "Blocked"
}
